<template>
  <div>
    <div class="direct-chat">
      <div class="box-header">
        <h3 class="box-title"><i class="fa fa-calendar-o mr-5"></i>{{'store_ranking' | translate}}</h3>
      </div>
      <div class="box-body">
        <div class="direct-chat-messages">
          <ul class="timeline">
            <template v-for="t in transitions">
            <li class="time-label">
              <span><i class="fa fa-calendar-o mr-5"></i>{{t.date}}</span>
            </li>
            <li v-for="(e, index) in t.transitions">
              <i :class="[getClass(e.event).icon, getClass(e.event).style]"></i>
              <div class="timeline-item" :key="e.id">
                <div class="timeline-header">
                  <span class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{e.time}}</span>
                  <span :class="getClass(e.event).style">{{e.event | translate}}</span>
                </div>
                <div class="timeline-body" v-if="e.event !== 'approved'">
                  <div class="col-xs-12">
                    <label>{{'points' | translate}}</label>
                    <input v-validate="{required: true, regex:/^-?([0-9]+|[0-9]+,[0-9]{0,2}?)$/ }" :disabled="isLoading[t.date][index]" :data-vv-scope="`event-${e.id}`" data-vv-as="Ranking" class="form-control" name="ranking" type="text" v-model="e.ranking">
                    <span v-show="errors.has(`event-${e.id}.ranking`)" class="small text-danger">{{ errors.first(`event-${e.id}.ranking`) }}</span>
                  </div>
                  <div class="col-xs-12 mt-10">
                    <label>{{'write_note' | translate}}</label>
                    <textarea v-validate="'required'" :data-vv-scope="`event-${e.id}`" data-vv-as="message" name="message" class="form-control" placeholder="Notizeintrag..." :disabled="isLoading[t.date][index]" v-model="e.message"></textarea>
                    <span v-show="errors.has(`event-${e.id}.message`)" class="small text-danger">{{ errors.first(`event-${e.id}.message`) }}</span>
                  </div>
                  <div class="col-xs-12 mt-10">
                    <b-btn :disabled="errors.any(`event-${e.id}`) || isLoading[t.date][index]" :class="getClass(e.event).btn" @click="rank(e, `event-${e.id}`, t.date, index)">
                      <template v-if="isLoading[t.date][index]">
                        <i class="fa fa-spinner fa-spin"></i>
                      </template>
                      <template v-else>
                        {{'update_history' | translate}}
                      </template>
                    </b-btn>
                  </div>
                  <template v-for="alert in alerts[t.date][index]">
                    <div class="col-xs-12 mt-10">
                      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
                        <i v-if="alert.type === 'success' || alert.type === 'warning' "class="icon fa fa-check"></i>
                        <i class="icon fa fa-ban" v-else></i>{{alert.message | translate}}
                      </b-alert>
                    </div>
                  </template>
                  <div class="col-xs-12 mt-10" v-if="e.created || e.updated">
                    <hr>
                    <span class="text-italics">{{'created' | translate}}: {{e.created}}, Updated: {{e.updated}}</span>
                    <br><span class="text-italics text-muted">Original points: {{e.original_points}}</span>
                  </div>
                </div>
              </div>
            </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['transitions', 'main'],
    data () {
      return {
        show: true,
        isLoading: [],
        alerts: []
      }
    },
    methods: {
      getClass (e) {
        switch (e) {
          case 'shipped':
            return {icon: 'fa fa-truck', style: 'text-success', btn: 'btn btn-success'}
          case 'initial':
            return {icon: 'fa fa-cloud-download', style: 'text-primary', btn: 'btn btn-primary'}
          case 'approved':
            return {icon: 'fa fa-thumbs-up', style: 'text-info', btn: 'btn btn-info'}
          case 'fulfilled':
            return {icon: 'fa fa-check', style: 'text-teal', btn: 'btn btn-info'}
          case 'cancelled':
          case 'canceled':
            return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
          case 'mp_cancellation':
            return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
          case 'customer_cancellation':
            return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
          case 'returned':
            return {icon: 'fa fa-reply', style: 'text-warning', btn: 'btn btn-warning'}
        }
      },
      rank (e, scope, date, index) {
        this.isLoading[date][index] = true
        this.$validator.validateAll(scope)
          .then(result => {
            if (result) {
              API.put(`/orders/transition/${e.id}/rank`, {points: e.ranking.replace(',', '.'), message: e.message})
                .then(response => {
                  this.isLoading[date][index] = false
                  let alert = {type: 'success', dismiss: 4, message: 'update_successful'}
                  this.alerts[date][index].push(alert)
                })
                .catch(error => {
                  this.isLoading[date][index] = false
                  let alert = {type: 'danger', dismiss: 4, message: 'update_error'}
                  this.alerts[date][index].push(alert)
                })
            } else {
              this.isLoading[date][index] = false
              let alert = {type: 'danger', dismiss: 4, message: 'update_error'}
              this.alerts[date][index].push(alert)
            }
          })
      }
    },
    watch: {
      transitions () {
        this.transitions.forEach(t=> {
          this.$set(this.isLoading, t.date, [])
          this.$set(this.alerts, t.date, [])
          t.transitions.forEach(x => {
            this.isLoading[t.date].push(false)
            this.alerts[t.date].push([])
          })
        })
      }
    }
  }
</script>
<style scoped>
  .text-italics{
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/OrderHistory.vue